import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Suspense, lazy } from 'react';
import { createHashRouter } from 'react-router-dom';

const Home = lazy(() => import('@/pages/home'));
const Layout = lazy(() => import('@/pages/layout'));
const Products = lazy(() => import('@/pages/products'));
const Design = lazy(() => import('@/pages/design'));
const Edit = lazy(() => import('@/pages/edit'));
const My = lazy(() => import('@/pages/my'));
const Preview = lazy(() => import('@/pages/preview'));
const ModelPage = lazy(() => import('@/pages/model'));
const Order = lazy(() => import('@/pages/order'));
const Share = lazy(() => import('@/pages/share'));
const Page404 = lazy(() => import('@/pages/404'));

const Loading = () => (
  <div className="w-full h-screen flex items-center justify-center">
    <Spin indicator={<LoadingOutlined spin style={{ fontSize: 48 }} />} />
  </div>
);

const S = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<Loading />}>{children}</Suspense>
);

export const router = createHashRouter(
  [
    {
      path: '/',
      element: <S><Home /></S>,
    },
    {
      element: <S><Layout /></S>,
      children: [
        {
          path: '/products',
          element: <S><Products /></S>,
        },
        {
          path: '/design',
          element: <S><Design /></S>,
        },
        {
          path: '/edit',
          element: <S><Edit /></S>,
        },
        {
          path: '/my',
          element: <S><My /></S>,
        },
        {
          path: '/preview/:id',
          element: <S><Preview /></S>,
        },
      ],
    },
    {
      path: '/model/:id',
      element: <S><ModelPage /></S>,
    },
    {
      path: '/order/:id',
      element: <S><Order /></S>,
    },
    {
      path: '/share/:id',
      element: <S><Share /></S>,
    },
    {
      path: '*',
      element: <S><Page404 /></S>,
    },
  ],
);
